import { supabase } from './supabase';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

const optimizeImage = async (file) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true
  };

  try {
    return await imageCompression(file, options);
  } catch (error) {
    console.error('Error optimizing image:', error);
    return file;
  }
};

export const uploadContentImage = async (file, projectId) => {
  try {
    // Optimize image before upload
    const optimizedFile = await optimizeImage(file);

    // Create a unique file path including project ID for organization
    const fileExt = file.name.split('.').pop();
    const fileName = `${projectId}/${uuidv4()}.${fileExt}`;
    const filePath = `${fileName}`;

    // Upload the optimized file
    const { data, error } = await supabase.storage
      .from('content_images')
      .upload(filePath, optimizedFile);

    if (error) throw error;

    // Get the public URL
    const { data: { publicUrl } } = supabase.storage
      .from('content_images')
      .getPublicUrl(filePath);

    return {
      path: filePath,
      url: publicUrl,
      size: optimizedFile.size,
      type: optimizedFile.type,
      name: file.name
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

export const deleteContentImage = async (filePath) => {
  try {
    const { error } = await supabase.storage
      .from('content_images')
      .remove([filePath]);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error;
  }
}; 